export default {
  reset: 'Reset',
  pleaseScan: 'Please scan the ',
  blurTip: 'Please move the cursor to the UPC input box',
  connectError: 'Unable to connect to NFC device. Please restart the device and refresh the page',
  multipleNfcError: 'Multiple NFC, please read again',
  uidEmptyError: 'NFC Uid can’t be empty',
  uidExistsError: 'NFC already tag',
  upcEmptyError: 'UPC can’t be empty',
  skuNotExistError: 'SKU doesn’t exist in the NFC SKU list, please contact admin',
  nfcHasBoundError: 'NFC has already been bound',
  illegalUpcError: 'Illegal UPC',
  macError:
    'Unable to recognize middleware. If binding is required, please start all middleware and ensure that the tablet has been started before logging in again',
  workstationError:
    'Unable to recognize workbench. If binding is required, please contact the administrator and log in again',
  backText: 'Return to previous page',
  loginText: 'Re login',
  tagType: 'SKU should tag ',
  NFCUIDInvalid: 'NFC UID invalid',
  NFCUIDDisabled: 'NFC UID Disabled',
  tagTypeNotMatch: 'SKU should bind type',
  nddcTagTypeNotMatch: 'should bind type',
  requiredTagType: 'Required Tag Type:',
  actualTagType: 'Actual Tag Type:',
  rfMacError: 'Unable to recognize middleware. Please start middleware in desktop app "Nike T-hub" and re-login',
  tagTypeError: 'Tag type not obtained, please try again'
}
